import { LIMPAR_FILTRO_ITINERARIO_EMBARQUE } from '../types'

export default function limparFiltroItinerarioEmbarque () {
  return {
    type: LIMPAR_FILTRO_ITINERARIO_EMBARQUE
  }
}
